import { createFileRoute } from "@tanstack/react-router";
import Examination from "../../app/views/competence/examination";

export const Route = createFileRoute("/competence/examination")({
  component: Examination,
});
